<template>
    <v-data-table :headers="headers" :items="items" :items-per-page="10" :options.sync="options"
        :server-items-length="totalItems" item-key="id" :loading="isLoading" :loading-text="$t('loadingPleaseWait')"
        :no-data-text="$t('noData')" :footer-props="footerProps" :header-props="headerProps">
        <template v-slot:item.image="{ item }">
            <v-img v-if="item.imageUrl" :src="item.imageUrl" max-width="80" max-height="48" contain
                class="my-2"></v-img>
            <span v-else>—</span>
        </template>
        <template v-slot:item.link="{ item }">
            <v-tooltip v-if="item.link" top>
                <template v-slot:activator="{ on, attrs }">
                    <a :href="item.link" target="_blank" rel="noopener noreferrer" v-bind="attrs" v-on="on">Open
                        Link</a>
                </template>
                <span>{{ item.link }}</span>
            </v-tooltip>
            <span v-else>—</span>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon small @click="$emit('update', item.id)">edit</v-icon>
        </template>
    </v-data-table>
</template>

<script>
import { PartnerManufacturerShowcasesService } from "../../../services";
import { MixinTableLoadState } from '../../../mixins'

export default {
    name: "PartnerManufacturerShowcasesTable",
    mixins: [MixinTableLoadState],
    props: ['filters'],
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            totalItems: null,
            footerProps: {
                'items-per-page-text': this.$t('rowsPerPage'),
                'items-per-page-all-text': this.$t('all'),
            },
            headerProps: {
                sortByText: this.$t('sortBy'),
            },
        }
    },
    methods: {
        setItems() {
            if (!this.startTableLoading()) return;

            const params = {
                ...this.options,
                filters: this.filters,
            };

            PartnerManufacturerShowcasesService.getShowcases(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        setTable() {
            PartnerManufacturerShowcasesService.getTableData()
                .then(res => {
                    this.headers = res.data.headers;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                });
        },
    },
    created() {
        PartnerManufacturerShowcasesService.setAuth(this.$store.getters.token);
        this.setTable();
    },
    watch: {
        options: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
        filters: {
            handler() {
                this.setItems();
            },
            deep: true,
        },
    },
}
</script>
